import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import FlexBox from 'components/FlexBox';
import injectReducer from 'utils/injectReducer';
import { makeSelectStep17 } from './selectors';
import reducer from './reducer';
import PageSectionHeader from '../components/PageSectionHeader';
import Textbox from '../components/Textbox';
import DatePicker from '../components/DatePicker';
import TextArea from '../components/TextArea';
import messages from './messages';
import {
  handleFormDataChange,
} from './actions';
import OptionsContainer from '../components/OptionsContainer';
import { Button } from '../components/Button';
import { saveFormData } from '../actions';
import {
  ValidateGroup,
} from '../../../components/Validation/';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import CurrencySelector from '../components/CurrencySelector';

class Step17 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };

    this.validatorGroup = new ValidateGroup();
    this.saveButtonId = _.uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;

    this.onResize = this.onResize.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }
  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'radio') {
      this.props.adjust();
    }
    this.props.onFormDataChange(propertyName, value);
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
  }

  handleChangeNameOfDeceased = (propertyName) => (event) => {
    const { checkNameOfDeceased } = this.props.form;
    const checkNameOfDeceases = !!checkNameOfDeceased && typeof checkNameOfDeceased.toJS === 'function'
    ? checkNameOfDeceased.toJS()
    : checkNameOfDeceased || [];

    const listChecked = _.cloneDeep(checkNameOfDeceases);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleDayChange = (propertyName) => (day) => {
    const localDate = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, localDate);
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }
    this.checkFormError();

    this.props.onFormDataSave();
    this.props.next();
  };

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  render() {
    const { isSummary, submitted, loading } = this.props;

    const {
      benefitAreYouClaimingFor,
      assistance,
      dateApproved,
      causeOfDeath,
      dateOfDeath,
      stateOfDeath,
      countryOfDeath,
      wasTheMemberHospitalized,
      fromDate,
      toDate,
      nameOfFuneralServiceProvider,
      costOfLocalBurial,
      invoice,
      amountClaimed,
      costOfLocalBurialCurrency,
      amountClaimedCurrency,
      familyMemberProvidingInformation,
      relationshipToMember,
      address,
      cityOrTown,
      country,
      postalCode,
      phoneNumber,
    } = isSummary ? this.summaryFormValue() : this.props.form;

    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        <div className={'row'}>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.benefitAreYouClaimingFor} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="Local Burial"
                  checked={benefitAreYouClaimingFor === 'Local Burial'}
                  onChange={this.handleChange('form.benefitAreYouClaimingFor')}
                />
                <FormattedMessage {...messages.localBurial} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="Repatriation"
                  checked={benefitAreYouClaimingFor === 'Repatriation'}
                  onChange={this.handleChange('form.benefitAreYouClaimingFor')}
                />
                <FormattedMessage {...messages.repatriation} />
              </OptionsContainer>
            </FlexBox>
          </div>
          <div className={'form-group col-sm-6'}>
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.assistance} />
            </PageSectionHeader>
            <Textbox
              name="assistance"
              type="text"
              disabled={isReadOnly}
              onChange={this.handleChange('form.assistance')}
              value={assistance}
            />
          </div>
          <div className={'form-group col-sm-6'}>
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.dateApproved} />
            </PageSectionHeader>
            <DatePicker
              position={'bottom-start'}
              disabled={isReadOnly}
              name="dateApproved"
              type="text"
              onDayChange={this.handleDayChange('form.dateApproved')}
              value={dateApproved}
            />
          </div>
          <div className={'form-group col-sm-6'}>
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-12'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.causeOfDeath} />
            </PageSectionHeader>
            <TextArea
              disabled={isReadOnly}
              name="causeOfDeath"
              type="text"
              onChange={this.handleChange('form.causeOfDeath')}
              value={causeOfDeath}
              isSummary={isSummary}
            />
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-4'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.dateOfDeath} />
            </PageSectionHeader>
            <DatePicker
              position={'bottom-start'}
              disabled={isReadOnly}
              name="dateOfDeath"
              type="text"
              onDayChange={this.handleDayChange('form.dateOfDeath')}
              value={dateOfDeath}
            />
          </div>
          <div className={'form-group col-sm-4'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.stateOfDeath} />
            </PageSectionHeader>
            <Textbox
              name="stateOfDeath"
              type="text"
              disabled={isReadOnly}
              onChange={this.handleChange('form.stateOfDeath')}
              value={stateOfDeath}
            />
          </div>
          <div className={'form-group col-sm-4'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.countryOfDeath} />
            </PageSectionHeader>
            <Textbox
              name="countryOfDeath"
              type="text"
              disabled={isReadOnly}
              onChange={this.handleChange('form.countryOfDeath')}
              value={countryOfDeath}
            />
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-4'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.wasTheMemberHospitalized} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="true"
                  checked={wasTheMemberHospitalized === 'true'}
                  onChange={this.handleChange('form.wasTheMemberHospitalized')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={wasTheMemberHospitalized === 'false'}
                  onChange={this.handleChange('form.wasTheMemberHospitalized')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
          { wasTheMemberHospitalized === 'true' && (
          <div className={'form-group col-sm-8'}>
            <div className={'row'}>
              <div className={'form-group col-sm-6'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.from} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="fromDate"
                  type="text"
                  onDayChange={this.handleDayChange('form.fromDate')}
                  value={fromDate}
                />
              </div>
              <div className={'form-group col-sm-6'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.to} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="toDate"
                  type="text"
                  onDayChange={this.handleDayChange('form.toDate')}
                  value={toDate}
                />
              </div>
            </div>
          </div>
          )}
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.nameOfFuneralServiceProvider} />
            </PageSectionHeader>
            <Textbox
              name="nameOfFuneralServiceProvider"
              type="text"
              disabled={isReadOnly}
              onChange={this.handleChange('form.nameOfFuneralServiceProvider')}
              value={nameOfFuneralServiceProvider}
            />
          </div>
          <div className={'form-group col-sm-6'}>
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.costOfLocalBurial} />
            </PageSectionHeader>
            <Textbox
              name="costOfLocalBurial"
              type="text"
              disabled={isReadOnly}
              onChange={this.handleChange('form.costOfLocalBurial')}
              value={costOfLocalBurial}
            />
          </div>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.currency} />
            </PageSectionHeader>
            <CurrencySelector
              name="costOfLocalBurialCurrency"
              disabled={isReadOnly}
              value={costOfLocalBurialCurrency}
              onChange={this.handleCurrencyChange('form.costOfLocalBurialCurrency')}
            />
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.invoice} />
            </PageSectionHeader>
            <Textbox
              name="invoice"
              type="text"
              disabled={isReadOnly}
              onChange={this.handleChange('form.invoice')}
              value={invoice}
            />
          </div>
          <div className={'form-group col-sm-6'}>
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.amountClaimed} />
            </PageSectionHeader>
            <Textbox
              name="amountClaimed"
              type="text"
              disabled={isReadOnly}
              onChange={this.handleChange('form.amountClaimed')}
              value={amountClaimed}
            />
          </div>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.currency} />
            </PageSectionHeader>
            <CurrencySelector
              name="amountClaimedCurrency"
              disabled={isReadOnly}
              value={amountClaimedCurrency}
              onChange={this.handleCurrencyChange('form.amountClaimedCurrency')}
            />
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.familyMemberProvidingInformation} />
            </PageSectionHeader>
            <Textbox
              name="familyMemberProvidingInformation"
              type="text"
              disabled={isReadOnly}
              onChange={this.handleChange('form.familyMemberProvidingInformation')}
              value={familyMemberProvidingInformation}
            />
          </div>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.relationshipToMember} />
            </PageSectionHeader>
            <Textbox
              name="relationshipToMember"
              type="text"
              disabled={isReadOnly}
              onChange={this.handleChange('form.relationshipToMember')}
              value={relationshipToMember}
            />
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-12'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.address} />
            </PageSectionHeader>
            <Textbox
              name="address"
              type="text"
              disabled={isReadOnly}
              onChange={this.handleChange('form.address')}
              value={address}
            />
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-4'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.cityOrTown} />
            </PageSectionHeader>
            <Textbox
              name="cityOrTown"
              type="text"
              disabled={isReadOnly}
              onChange={this.handleChange('form.cityOrTown')}
              value={cityOrTown}
            />
          </div>
          <div className={'form-group col-sm-4'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.country} />
            </PageSectionHeader>
            <Textbox
              name="country"
              type="text"
              disabled={isReadOnly}
              onChange={this.handleChange('form.country')}
              value={country}
             />
          </div>
          <div className={'form-group col-sm-4'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.postalCode} />
            </PageSectionHeader>
            <Textbox
              name="postalCode"
              type="text"
              disabled={isReadOnly}
              onChange={this.handleChange('form.postalCode')}
              value={postalCode}
            />
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-sm-6'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.phoneNumber} />
            </PageSectionHeader>
            <Textbox
              name="phoneNumber"
              type="text"
              disabled={isReadOnly}
              onChange={this.handleChange('form.phoneNumber')}
              value={phoneNumber}
            />
          </div>
          <div className={'form-group col-sm-6'}>
          </div>
        </div>
        {!isSummary && (
          <div className={'row justify-content-between mt-3'}>
            <div className={'col'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            {!submitted && (
              <div className={'col-12 col-sm-auto'}>
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onKeyDown={this.handleKeyDown}
                  onClick={this.handleSaveButtonClick}
                >
                  Save
                </AsyncButton>
              </div>
            )}
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

Step17.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  next: PropTypes.func,
  prev: PropTypes.func,
  onFormDataSave: PropTypes.func,
  adjust: PropTypes.func,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  loading: PropTypes.bool,
  makeError: PropTypes.func,
  makeValid: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  errors: PropTypes.any,
  isReadOnly: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStep17(),
  loading: makeSelectProgressBarStatus(),
  currentStep: makeSelectCurrentStep(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'step17', reducer });

export default compose(
  withReducer,
  withConnect
)(Step17);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step17/index.js